import { render } from "./CSelectGroup.vue?vue&type=template&id=5c85022e"
const script = {}

import "./CSelectGroup.vue?vue&type=style&index=0&id=5c85022e&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__